module.exports = __webpack_public_path__ + "3959cf404daf52df4e7ee4e51a53b677.svg";